import VehicleStatus from '@/dossier/constants/VehicleStatus';
import WorkStatus from '@/dossier/constants/WorkStatus';
import DossierSummary from '@/dossier/models/DossierSummary';
import { mergeInto } from '@/shared/utils';
import { DossierPage, DossierSearchCursor } from '../clients/StatusBoardClient';
import { DossierSearchCriteria } from './DossierSearchCriteria';

export default class StatusBoardColumn<Status = WorkStatus | VehicleStatus> {
  readonly dossiers: Array<DossierSummary>;
  nextCursor: DossierSearchCursor | null;

  constructor(
    readonly status: Status,
    readonly criteria: DossierSearchCriteria,
    page: DossierPage,
  ) {
    this.dossiers = page.dossiers;
    this.nextCursor = page.nextCursor;
  }

  hasMore(): boolean {
    return this.nextCursor !== null;
  }

  addPage(page: DossierPage): void {
    page.dossiers.forEach(dossier => this.mergeDossier(dossier));
    this.nextCursor = page.nextCursor;
  }

  mergeDossier(dossier: DossierSummary): void {
    mergeInto(dossier, this.dossiers);
  }
}